class DonsController {

  constructor() {
    var that = this;
  }

}

DonsController.$inject = [];

module.exports = DonsController;



// WEBPACK FOOTER //
// ./src/app/components/dons/dons.controller.js